import React, { useState,useEffect } from "react";
import LeftMenu01 from "../../components/layout/leftMenu01.jsx";
import Header from "../../components/layout/header-candidate.jsx";
import { backendApi } from "../../api/apiService";
import { useSelector } from "react-redux";
import moment from "moment";
export default function CandidateApplied() {
  const [menuClick, setMenuClick] = useState(false);
  const { candidateData } = useSelector((state) => state.login);
  const[appliedList,setAppliedList]=useState([])
  const toggleMenu = () => {
    setMenuClick(!menuClick)
  }
  const closeMenu = () => {
    setMenuClick(false)
  }
  useEffect(() => {
    getAppliedList();
    setTimeout(() => {
      document.getElementById("AppliedMenu").classList.add("active");
    }, 500);
   
  }, []);
  const getAppliedList=()=>{
    const req = {
      functionName: "getCandidateApplied",
      email_id: candidateData[0].email_id,
    };
    backendApi(req)
      .then((response) => {
        if (response.success === "1") {
          setAppliedList(response.appliedList);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  return (
    <div className="main-wrapper">
      <div className="top-color"></div>
      <LeftMenu01 menuClick={menuClick} closeMenu={closeMenu} />
      <div className="content-wrapper">
        <Header Header="Candidate Applied" toggleMenu={toggleMenu} menuClick={menuClick} />
        <div className="main-container">
          <div className="row mb-3">
            <div className="col-lg-12 col-md-12">
              <div className="card main-card-box">
                <div className="card-body">
                  <div className="row">
                    <div class="table-responsive">
                      <table class="table">
                        <thead>
                          <tr>
                            <th width="50px">Sl.No</th>
                            <th>Position</th>
                            <th>Description</th>
                            <th>Experience</th>                            
                            <th>Job Type</th>                            
                            <th>Location</th>
                            <th>Applied On</th>
                            <th>Skills</th>
                          </tr>
                        </thead>
                        <tbody>
                          {appliedList.map((data,index)=>(
                          <tr>
                            <td>{index+1}</td>
                            <td>{data.summary}</td>
                            <td>{data.description}</td>
                            <td>{data.experiance} years</td>                                                     
                            <td>{data.job_type}</td>
                            <td>{data.location}</td>
                            <td>{moment(data.applied_on).format("DD/MM/YY")}</td>
                            <td>
                              <div className="d-flex flex-flow-wrap">
                                {data.skills.map((skill,index)=>(
                                  <span key={index} className="skills-candidate">{skill.skill_name}</span>
                                ))}
                              </div>
                            </td>
                          </tr>))}
                         
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
